<template>
  <div>
    <el-autocomplete
      v-model="state"
      :fetch-suggestions="querySearchAsync"
      placeholder="隊編、姓名、電話"
      @select="handleSelect"
      @clear="handleClear"
      clearable
      autocomplete="off"
    />
  </div>
</template>
<script>
import API from '@/assets/js/libs/API'

export default {
  data() {
    return {
      state: '',
      timeout: null,
    }
  },
  methods: {
    getDriverList(kw, cb) {
      API.get(`driver-v2/list?task=search&kw=${kw}`)
        .then((res) => {
          this.drivers = res.result.driverList
          for (let i of this.drivers) {
            i.value = `${i.callNumber}-${i.name}` //將想要展示的資料作為value
          }
          clearTimeout(this.timeout)
          this.timeout = setTimeout(() => {
            cb(this.drivers)
          }, 1000 * Math.random())
        })
        .catch((err) => {
          console.log(err)
          this.$msg('網路連線異常')
        })
    },
    querySearchAsync(queryString, callback) {
      /* console.log('queryString', queryString) */
      this.getDriverList(queryString, callback)
    },
    createStateFilter(queryString) {
      return (state) => {
        return (
          state.address.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        )
      }
    },
    handleSelect(item) {
      this.$emit('handleSelect', item)
    },
    clearSelect() {
      this.state = ''
    },
    handleClear() {
      this.$emit('handleClear', '')
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/element_ui/InputAutocomplete.vue